import styled, {keyframes} from "styled-components";

const appearZoomIn = keyframes`
    0% {
        transform: scale(0.1);
        opacity: 0;
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
`;
export const WheelZoomInContainerDefaultBox = styled.div`
    animation: ${appearZoomIn} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
    
`;
